'use client';

import { PropertyDict } from 'mixpanel';
import { ssrTrackOnServer } from './ssr-track-server';

// This is cached on the client side, and should not change.
// If it does change, it is not a problem.
let cachedIp: string | undefined;

async function getIpAddress(): Promise<string | undefined> {
    if (!cachedIp) {
        try {
            const response = await fetch('https://ipinfo.io/json');
            const json = await response.json();
            if (json && typeof json === 'object' && 'ip' in json) {
                cachedIp = json['ip'];
            } else {
                console.warn(
                    `Response json has no 'ip':`,
                    JSON.stringify(json)
                );
            }
        } catch (e) {
            console.warn(`Failed to get IP info:`, e);
        }
    }

    return cachedIp;
}

function splitUrlParams(): PropertyDict | undefined {
    const search =
        typeof window === 'undefined' ? undefined : window.location.search;

    if (!search) {
        return undefined;
    }

    const params = new URLSearchParams(search);
    const properties: PropertyDict = {};

    for (const [k, v] of params.entries()) {
        properties['in:' + k] = v;
    }

    return properties;
}

/**
 * Track events on server side to workaround ad blockers. `eventName` will
 * be auto-prefixed with MIXPANEL_EVENT_PREFIX to identify the project.
 */
export async function ssrTrack(eventName: string, properties?: PropertyDict) {
    const ip = await getIpAddress();

    const extraProperties =
        typeof window === 'undefined'
            ? undefined
            : {
                  // Important to log the query params which captures all the form data
                  // the user has right now.
                  // Logging the origin makes the url copy-pastable into a browser
                  // directly, which is very convenient.
                  // Note that if we update the url after page navigation, this will log
                  // the original url before the update.
                  $current_url: window.location.href,

                  ...splitUrlParams(),
              };

    await ssrTrackOnServer(ip, eventName, {
        ...extraProperties,
        ...properties,
    });
}
